import { z } from 'zod';
import { ReservationPurpose } from '@mews-commander/data-access';

export const ReservationPurposeFormSchema = z.object({
    reservationPurpose: z.nativeEnum(ReservationPurpose).nullish(),
});

export type ReservationPurposeFormValues = z.infer<typeof ReservationPurposeFormSchema>;
